// import React from 'react'
// import MegaMenu from './MegaMenu'

// const ServicesMegaMenu = () => {
//   return (
//     <>
//     <MegaMenu menuName="Services" menuParagraph="Experience comprehensive solutions with our company, offering a range of services including solar panel installation, HMI development, drive integration, PLC programming, tube well/pump automation, and remote monitoring through flow meters and SCADA systems." firstLink=">Solar Services" secondLink="> Street Light Automation System" thirdLink="> Tube Well/Pump Automation System" fourthLink="> Flow Meter With Remote Monitoring System" fifthLink="> Application Software Development" sixthLink="> PLC, HMI, Drive & SCADA" url_1="/solar-services" url_2="/street-light-automation-services" url_3="/tube-well-pump-automation-services" url_4="/flow-meter-automation-services" url_5="/application-software-services" url_6="/plc-hmi-drive-and-scada" />
//     </>
//   )
// }

// export default ServicesMegaMenu

import React,{useState} from 'react';
import './ContactUsMenu.css';
import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { NavLink } from 'react-router-dom';
import { MegaMenuHover } from '../components/MegaMenuHover/MegaMenuHover';



const ServicesMegaMenu = () => {
  const [solarPannelSystems,setSolarPannelSystems]=useState(false);
  const [streetLight,setStreetLight]=useState(false);
  const [subMenu,setSubMenu]=useState(false);
  const [tubeWellPump,setTubeWellPump]=useState(false);
  const [flowMeter,setFlowMeter]=useState(false);
  const [applicationSoftware,setApplicationSoftware]=useState(false);
  const [plcHmiScadaDrive,setPlcHmiScadaDrive]=useState(false);
  return (
    <>
     <div id='services-menu' style={{}} onMouseOver={()=>setSubMenu(true)} onMouseOut={()=>setSubMenu(false)} onClick={()=>setSubMenu(!subMenu)} >
      {
        subMenu?<MegaMenuHover/>:null
      }
     {/* <NavLink to="/about-us" className="col" >About Us
                    
                    </NavLink> */}

      <NavLink to="/solar-services" onMouseOver={()=>setSolarPannelSystems(true)} onMouseOut={()=>setSolarPannelSystems(false)} onClick={()=>setSolarPannelSystems(!solarPannelSystems)} style={{textDecoration:"none"}}><p><ArrowRightAltIcon/> Solar water pump <br /> &nbsp; &nbsp; &nbsp; Automation System</p>
      {solarPannelSystems && <MegaMenuHover service="Solar Automation System" serviceDescription=
"Unique Technologies specializes in advanced solar automation services, optimizing energy efficiency and sustainability for a brighter, greener future." serviceImg="img-data/homepage/MegaMenu/solar-pannel-systems.jpg"/>}
      </NavLink>
      
      <NavLink to="/street-light-automation-services" onMouseOver={()=>setStreetLight(true)} onMouseOut={()=>setStreetLight(false)} onClick={()=>setStreetLight(!streetLight)} style={{textDecoration:"none"}}><p><ArrowRightAltIcon/> Street Light Automation <br />&nbsp; &nbsp; &nbsp; System</p>
      {streetLight && <MegaMenuHover service="Street Light Automation System" serviceDescription=

"Unique Technologies offers cutting-edge street light automation systems, illuminating roads intelligently with energy-efficient solutions for safer, smarter communities." serviceImg="img-data/homepage/MegaMenu/street-light-automation.jpg"/>}
      </NavLink>
      
     {/* <NavLink to="/tube-well-pump-automation-services" onMouseOver={()=>setTubeWellPump(true)} onMouseOut={()=>setTubeWellPump(false)} onClick={()=>setTubeWellPump(!tubeWellPump)} style={{textDecoration:"none"}}> <p><ArrowRightAltIcon/> Tube Well/Pump Automation <br />&nbsp; &nbsp; &nbsp; System</p>
     {tubeWellPump && <MegaMenuHover service="Tube Well/Pump Automation" serviceDescription=

"Experience enhanced efficiency and precision control of tube wells with our tailored automation solutions, ensuring optimal performance and seamless operation." serviceImg="img-data/homepage/MegaMenu/tube-well-automation.jpg"/>}
     </NavLink> */}
      
      <NavLink to="/flow-meter-automation-services" onMouseOver={()=>setFlowMeter(true)} onMouseOut={()=>setFlowMeter(false)} onClick={()=>setFlowMeter(!flowMeter)} style={{textDecoration:"none"}}><p><ArrowRightAltIcon/> Flow meter with remote <br />&nbsp; &nbsp; &nbsp; monitoring System</p>
      {flowMeter && <MegaMenuHover service="Flow Meter With Remote Monitoring System" serviceDescription=

"Our special flow meter can check how much liquid is moving. It can send this information far away so you can watch it." serviceImg="img-data/homepage/MegaMenu/flow-meter.jpg"/>}
      </NavLink>
      
      <NavLink to="/application-software-services" onMouseOver={()=>setApplicationSoftware(true)} onMouseOut={()=>setApplicationSoftware(false)} onClick={()=>setApplicationSoftware(!applicationSoftware)}  style={{textDecoration:"none"}}><p><ArrowRightAltIcon/> Application Software <br />&nbsp; &nbsp; &nbsp; Development</p>
      {applicationSoftware && <MegaMenuHover service="Application Software Development" serviceDescription=

"We specialize in creating custom computer programs to help businesses perform tasks more efficiently and effectively through application software development." serviceImg="img-data/homepage/MegaMenu/application-software.jpg"/>}</NavLink>
      
      <NavLink to="/plc-hmi-drive-and-scada"  onMouseOver={()=>setPlcHmiScadaDrive(true)} onMouseOut={()=>setPlcHmiScadaDrive(false)} onClick={()=>setPlcHmiScadaDrive(!plcHmiScadaDrive)}  style={{textDecoration:"none"}}><p><ArrowRightAltIcon/> PLC, HMI, Drive <br />&nbsp; &nbsp; &nbsp; & SCADA</p>
      {plcHmiScadaDrive && <MegaMenuHover service="PLC, HMI, SCDA And Drives" serviceDescription=

"Our comprehensive services cover PLC, HMI, SCADA, and Drive systems, ensuring seamless operation, efficient control, and optimal performance for your industrial processes." serviceImg="img-data/homepage/MegaMenu/plc-hmi-scada.jpg"/>}
      </NavLink>
     </div>
    </>
  )
}

export default ServicesMegaMenu

